import { ActionComponent, Component } from "components/components/Component";
import { EventActionDefinition } from "./eventActions";

export class ComponentActionHelper {

    private constructor(component: ActionComponent) {
        const view = (component["view"] as Element);
        for (const actionEvent of component.definition.eventActions ?? []) {
            let eventName = actionEvent.event.type === "change" ? "dataChanged" : actionEvent.event.type;
            view.addEventListener(eventName, (evt: CustomEvent) => {
                if (evt.detail?.initializationChange) {
                    return;
                }
                setTimeout(() =>
                    this.fireComponentActionEvent(view, component, actionEvent)
                    , 0);
            });
        }
    }

    private fireComponentActionEvent(view: Element, component: ActionComponent, actionEvent: EventActionDefinition) {
        view.dispatchEvent(new CustomEvent(
            "componentActionEvent",
            {
                bubbles: true,
                detail: {
                    component,
                    action: actionEvent,
                },
            }));
    }

    public static register(component: ActionComponent): void {
        // tslint:disable-next-line: no-unused-expression
        new ComponentActionHelper(component);
    }
}

export interface ComponentActionEventDetail {
    component: Component;
    action: EventActionDefinition;
}
